import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  createMuiTheme,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteLocalidad,
  getLocalidadById,
  postLocalidad,
  updateLocalidad,
} from "../../../../api/localidad";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { checkIsEmpty } from "../../../../utils/helpers";
import { getProvincias } from "../../../../api/provincia";
import { Autocomplete } from "@material-ui/lab";

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyCity() {
  return {
    fullName: "",
    provincia: "",
  };
}

export default function EditLocalidadesPage() {
  const [city, setCity] = useState(getEmptyCity());
  const [provinces, setProvinces] = useState([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const cityId = useParams().id;
  const history = useHistory();

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    getProvincias().then((res) => {
      setProvinces(res.data);
    });
    if (!cityId) {
      disableLoadingData();
      return;
    }
    getLocalidadById(cityId)
      .then((res) => {
        console.log(res.data)
        setCity(res.data);
        disableLoadingData();
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get the city.",
        });
        history.push("/cities");
      });
  }, [cityId, disableLoadingData, history]);

  function saveLocalidad() {
    if (checkIsEmpty(city.fullName))
      return alertError({
        error: null,
        customMessage: "Name is required.",
      });
    if (!cityId) {
      postLocalidad(cityId)
        .then((res) => {
          alertSuccess({
            title: "Saved!",
            customMessage: "City created successfully.",
          });
          history.push("/cities");
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not saved the city.",
          });
        });
    } else {
      updateLocalidad(cityId, city)
        .then((res) => {
          alertSuccess({
            title: "Saved!",
            customMessage: "Changes saved successfully.",
          });
          history.push("/cities");
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save the changes.",
          });
        });
    }
  }

  const handleChange = (element) => (event) => {
    setCity({ ...city, [element]: event.target.value });
  };

  if (isLoadingData)
    return <ContentSkeleton />;

  return (
    <>
      <Card>
        <CardHeader title="Editar city"></CardHeader>
        <CardBody>
          <div className="d-flex align-item-center">
            <div className="col-4">
              <TextField
                label="City name"
                value={city.fullName}
                onChange={handleChange("fullName")}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
            <div className="col-4">
              <Autocomplete
                id='Provinces'
                options={provinces}
                value={city.provincia || null}
                getOptionLabel={(option) => option.fullName}
                onChange={(_, newValue) => {
                  setCity({
                    ...city,
                    provincia: newValue,
                  })
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Province'
                    margin="normal"
                    variant="outlined"
                  />
                )}
              />
            </div>
          </div>
        </CardBody>
      </Card>


      <Button
        onClick={() => history.push("/cities")}
        variant="outlined"
        style={{ marginRight: "20px" }}
      >
        Back
      </Button>

      <Button
        onClick={() => saveLocalidad()}
        variant="outlined"
        color="primary"
        style={{ marginRight: "20px" }}
      >
        Save city
      </Button>

      {cityId && (
        <>
          <MuiThemeProvider theme={theme}>
            <Button
              onClick={() => setOpenConfirmDialog(true)}
              variant="outlined"
              color="secondary"
            >
              Delete city
            </Button>
          </MuiThemeProvider>

          <ConfirmDialog
            title={"Are you sure you want to delete this city?"}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteLocalidad(cityId)
                .then((res) => {
                  alertSuccess({
                    title: "Deleted!",
                    customMessage: "City deleted successfully.",
                  });
                  history.push("/cities");
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not deleted the city.",
                  });
                });
            }}
          />
        </>
      )}
    </>
  );
}
